import { handleActions } from 'redux-actions';
import { getActionOptions } from 'src/lib/reduxActionsUtils';
import { actionTypes, ACTION_PREFIX, PARTITION } from './constants';

const initialPartitionState = {
  count: 0,
};

const reducers = handleActions(
  {
    [`${actionTypes.ADD_COUNT}`]: (state) => {
      return {
        ...state,
        count: state.count + 1,
      };
    },
    [`${actionTypes.SUBTRACT_COUNT}`]: (state) => {
      return {
        ...state,
        count: state.count === 0 ? state.count : state.count - 1,
      };
    },
  },
  initialPartitionState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducers,
};
